import {ArenaFiltersConfigurationMap, IArenaViewModel} from "../arena-view-model.interface";
import {GameInfo} from "../../../../games/game-info";
import {IGamesFilterStrategy} from "../../../../games-filter/strategies/games-filter-strategy.interface";
import {VIDEO_SLIDES_ARENA} from "../../../arena-consts";
import {VideoSlidesArena} from "../../../../../components/arena-host/video-slides-arena/video-slides-arena.component";

export default class VideoSlidesArenaModel implements IArenaViewModel {
    constructor(private readonly services) {
    }
    readonly allArenaGamesForFiltering: GameInfo[];
    readonly filteredGamesCount: number;
    readonly filtersConfigurationMap: ArenaFiltersConfigurationMap;
    readonly listsCount: number;
    maxGamesToShowInList: number;
    currentLoadedShorts = this.services.videoSlides.slideList;

    readonly arenaName: string = VIDEO_SLIDES_ARENA;



    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return [];
    }

    getGamesFilteringStrategy(): IGamesFilterStrategy {
        return undefined;
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    renderArena(): React.ReactElement | null {
        return (<VideoSlidesArena />)
    }

    renderList(listPosition: number): React.ReactElement | null {
        return undefined;
    }

}